<template>
  <div class="estoque-wrapper">
    
    <EstoqueTabs
      :activeTab="activeSubTab"
      @change="activeSubTab = $event"
    />
    
    <div class="external-actions">
      <button v-if="activeSubTab === 'produtos'" class="btn-new" @click="openProdutoModal(null)">
        <span class="material-icons-outlined">add</span> Novo Produto
      </button>
      
      <button v-if="activeSubTab === 'estoque'" class="btn-new" @click="abrirModalNovoInventario()">
        <span class="material-icons-outlined">add</span> Nova Matéria Prima
      </button>
    </div>
    
    <TabelaProdutos
      v-if="activeSubTab === 'produtos'"
      :produtos="produtos"
      :inventario="inventario"
      @edit="openProdutoModal"
      @upload="openUploadModal"
      @delete="abrirModalDeletar"
    />
    
    <div v-if="activeSubTab === 'estoque'" class="table-container fade-in">
      <table v-if="inventario.length > 0">
        <thead>
        <tr>
          <th>ID</th>
          <th>Recurso</th>
          <th>Qtd. Atual</th>
          <th class="actions-cell">Ações</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in inventario" :key="item.id">
          <td>#{{ item.id }}</td>
          <td><strong>{{ item.nome_recurso }}</strong></td>
          <td><span class="estoque-badge">{{ item.quantidade }}</span></td>
          <td class="actions-cell">
            <button @click="openInventarioModal(item)" class="action-btn edit" title="Editar">
              <span class="material-icons-outlined">edit</span>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-else class="empty-state">Nenhum item de inventário encontrado.</div>
    </div>
    
    <ModalProdutoForm
      v-if="showProdutoModal"
      :produto="produtoParaEditar"
      :inventario="inventario"
      :loading="loading"
      @close="closeProdutoModal"
      @save="salvarProduto"
    />
    
    <ModalEstoqueForm
      v-if="itemParaEditar"
      :item="itemParaEditar"
      :loading="loading"
      @close="closeInventarioModal"
      @save="salvarNovoEstoque"
    />
    
    <ModalImagem
      v-if="produtoParaUpload"
      :produto="produtoParaUpload"
      :loading="loading"
      @close="closeUploadModal"
      @upload="enviarUpload"
      @delete-image="deletarImagem"
    />
    
    <BaseModal v-if="showNovoInventario" @close="fecharModalNovoInventario">
      <template v-slot:title>Nova Matéria Prima</template>
      <div class="modal-form-wrapper">
        <div class="form-group">
          <label>Nome do Recurso</label>
          <input v-model="novoInventario.nome" type="text" class="input-tatu" placeholder="Ex: Cartela de Ovos, Milho..." required ref="inputNovoInv">
        </div>
        <div class="form-group">
          <label>Quantidade Inicial</label>
          <input v-model.number="novoInventario.quantidade" type="number" class="input-tatu" placeholder="0" min="0">
        </div>
      </div>
      <template v-slot:actions>
        <button @click="fecharModalNovoInventario" class="modal-btn-no">Cancelar</button>
        <button @click="criarInventario" class="modal-btn-yes" :disabled="loading">
          {{ loading ? 'Salvando...' : 'Criar' }}
        </button>
      </template>
    </BaseModal>
    
    <BaseModal v-if="produtoParaDeletar" @close="fecharModalDeletar">
      <template v-slot:title>
        <span style="color: #F44336;">Excluir Produto</span>
      </template>
      <div class="confirmation-content">
        <div class="warning-icon-container">
          <span class="material-icons-outlined icon-warn">warning</span>
        </div>
        <p>
          Tem certeza que deseja excluir o produto <strong>"{{ produtoParaDeletar.nome }}"</strong>?
        </p>
        <p class="sub-warn">Esta ação não pode ser desfeita.</p>
      </div>
      <template v-slot:actions>
        <button @click="fecharModalDeletar" class="modal-btn-no" :disabled="loading">
          Cancelar
        </button>
        <button @click="confirmarDelecao" class="modal-btn-danger" :disabled="loading">
          {{ loading ? 'Excluindo...' : 'Excluir Definitivamente' }}
        </button>
      </template>
    </BaseModal>
  
  </div>
</template>

<script>
import api from '@/services/api';
import { AlertBus } from '@/plugins/AlertBus.js';

import BaseModal from './BaseModal.vue';
import EstoqueTabs from './estoque/EstoqueTabs.vue';
import TabelaProdutos from './estoque/TabelaProdutos.vue';
import ModalProdutoForm from './estoque/ModalProdutoForm.vue';
import ModalEstoqueForm from './estoque/ModalEstoqueForm.vue';
import ModalImagem from './estoque/ModalImagem.vue';

export default {
  name: "AdminEstoque",
  components: {
    BaseModal,
    EstoqueTabs,
    TabelaProdutos,
    ModalProdutoForm,
    ModalEstoqueForm,
    ModalImagem
  },
  props: {
    inventario: { type: Array, default: () => [] },
    produtos: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      activeSubTab: 'produtos',
      
      // Modais
      produtoParaEditar: null,
      showProdutoModal: false,
      itemParaEditar: null,
      produtoParaUpload: null,
      produtoParaDeletar: null,
      showNovoInventario: false,
      novoInventario: { nome: '', quantidade: 0 }
    };
  },
  watch: {
    activeSubTab(newTab) {
      if (this.$route.query.subtab !== newTab) {
        this.$router.replace({ query: { ...this.$route.query, subtab: newTab } }).catch(()=>{});
      }
    }
  },
  mounted() {
    const subTabFromUrl = this.$route.query.subtab;
    if (subTabFromUrl && ['produtos', 'estoque'].includes(subTabFromUrl)) {
      this.activeSubTab = subTabFromUrl;
    }
  },
  methods: {
    // === PRODUTOS ===
    openProdutoModal(prod) {
      this.produtoParaEditar = prod ? { ...prod } : null;
      this.showProdutoModal = true;
    },
    closeProdutoModal() {
      this.showProdutoModal = false;
      this.produtoParaEditar = null;
    },
    async salvarProduto(payload) {
      this.loading = true;
      try {
        if (payload.id) {
          await api.put(`/api/admin/produtos/${payload.id}`, payload);
        } else {
          await api.post(`/api/admin/produtos`, payload);
        }
        AlertBus.$emit('show-alert', { message: 'Produto salvo com sucesso!', type: 'success' });
        this.$emit('refresh');
        this.closeProdutoModal();
      } catch (err) {
        console.error(err);
        AlertBus.$emit('show-alert', { message: 'Erro ao salvar produto.', type: 'erro' });
      } finally {
        this.loading = false;
      }
    },
    abrirModalDeletar(prod) { this.produtoParaDeletar = prod; },
    fecharModalDeletar() { if (!this.loading) this.produtoParaDeletar = null; },
    async confirmarDelecao() {
      if (!this.produtoParaDeletar) return;
      this.loading = true;
      try {
        await api.delete(`/api/admin/produtos/${this.produtoParaDeletar.id}`);
        AlertBus.$emit('show-alert', { message: 'Produto excluído.', type: 'success' });
        this.$emit('refresh');
      } catch (err) {
        AlertBus.$emit('show-alert', { message: 'Erro ao excluir.', type: 'erro' });
      } finally {
        this.loading = false;
        this.fecharModalDeletar();
      }
    },
    
    // === IMAGENS ===
    openUploadModal(prod) { this.produtoParaUpload = prod; },
    closeUploadModal() { this.produtoParaUpload = null; },
    async enviarUpload(file) {
      if (!file || !this.produtoParaUpload) return;
      this.loading = true;
      const formData = new FormData();
      formData.append('image', file);
      try {
        await api.post(`/api/admin/produtos/${this.produtoParaUpload.id}/upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        AlertBus.$emit('show-alert', { message: 'Imagem enviada!', type: 'success' });
        this.$emit('refresh');
        this.closeUploadModal();
      } catch (err) {
        const msg = err.response?.data?.error || 'Erro ao enviar imagem.';
        AlertBus.$emit('show-alert', { message: msg, type: 'erro' });
      } finally {
        this.loading = false;
      }
    },
    async deletarImagem(imgUrl) {
      if (!confirm("Tem certeza que deseja excluir esta imagem?")) return;
      const filename = imgUrl.split('/').pop();
      const prodId = this.produtoParaUpload.id;
      this.loading = true;
      try {
        await api.delete(`/api/admin/produtos/${prodId}/images/${filename}`);
        AlertBus.$emit('show-alert', { message: 'Imagem removida.', type: 'success' });
        if (this.produtoParaUpload && this.produtoParaUpload.images) {
          this.produtoParaUpload.images = this.produtoParaUpload.images.filter(url => url !== imgUrl);
        }
        this.$emit('refresh');
      } catch (err) {
        const msg = err.response?.data?.error || 'Erro ao excluir imagem.';
        AlertBus.$emit('show-alert', { message: msg, type: 'erro' });
      } finally {
        this.loading = false;
      }
    },
    
    // === ESTOQUE (MATÉRIA PRIMA) ===
    openInventarioModal(item) { this.itemParaEditar = item; },
    closeInventarioModal() { if (!this.loading) this.itemParaEditar = null; },
    async salvarNovoEstoque(payload) {
      this.loading = true;
      try {
        await api.put(`/api/admin/inventario/${payload.id}`, { quantidade: payload.quantidade });
        AlertBus.$emit('show-alert', { message: 'Estoque atualizado!', type: 'success' });
        this.$emit('refresh');
        this.closeInventarioModal();
      } catch (err) {
        const errorText = err.response?.data?.error || err.message;
        AlertBus.$emit('show-alert', { message: errorText, type: 'erro' });
      } finally {
        this.loading = false;
      }
    },
    
    // === NOVA MATÉRIA PRIMA ===
    abrirModalNovoInventario() {
      this.novoInventario = { nome: '', quantidade: 0 };
      this.showNovoInventario = true;
      this.$nextTick(() => { if(this.$refs.inputNovoInv) this.$refs.inputNovoInv.focus(); });
    },
    fecharModalNovoInventario() { this.showNovoInventario = false; },
    async criarInventario() {
      if (!this.novoInventario.nome) {
        AlertBus.$emit('show-alert', { message: 'Nome é obrigatório.', type: 'alerta' });
        return;
      }
      this.loading = true;
      try {
        await api.post('/api/admin/inventario', this.novoInventario);
        AlertBus.$emit('show-alert', { message: 'Matéria prima criada!', type: 'success' });
        this.$emit('refresh');
        this.fecharModalNovoInventario();
      } catch (err) {
        const msg = err.response?.data?.error || 'Erro ao criar.';
        AlertBus.$emit('show-alert', { message: msg, type: 'erro' });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped src="@/assets/admin-styles.css"></style>
<style scoped>
/* Botões de Topo */
.external-actions {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;
  padding: 0 5px;
}

.btn-new {
  background-color: var(--color-button-buy);
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.2s;
}
.btn-new:hover { opacity: 0.9; }

/* Estilos específicos para modais inline */
.modal-form-wrapper { display: flex; flex-direction: column; gap: 15px; padding: 5px 0; }
.form-group { margin-bottom: 10px; text-align: left; }
.form-group label { display: block; margin-bottom: 6px; font-weight: 600; color: var(--text-main); font-size: 0.9rem; }
.input-tatu { width: 100%; padding: 12px; border: 1px solid var(--border-light); border-radius: 6px; background-color: var(--bg-main); color: var(--text-main); font-size: 1rem; transition: border-color 0.2s; box-sizing: border-box; }
.input-tatu:focus { outline: none; border-color: var(--color-accent); }
.modal-btn-yes { background-color: #4caf50; color: white; padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem; transition: all 0.2s; }
.modal-btn-no { padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem; background-color: var(--bg-icon-button); color: var(--text-main); border: 1px solid var(--border-light); }
.confirmation-content { text-align: center; padding: 10px 0; }
.warning-icon-container { margin-bottom: 15px; }
.icon-warn { font-size: 48px; color: #F44336; background-color: rgba(244, 67, 54, 0.1); padding: 15px; border-radius: 50%; }
.sub-warn { color: var(--text-secondary); font-size: 0.9rem; margin-top: 10px; }
.modal-btn-danger { background-color: #F44336; color: white; padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem; transition: all 0.2s; }
.modal-btn-danger:hover { background-color: #D32F2F; }
.fade-in { animation: fadeIn 0.3s ease; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
</style>